package tta.destinigo.talktoastro.shared.remote

import kotlinx.serialization.json.Json
import org.koin.dsl.module

val networkModule = module {
    single { createHttpClient(null) }
    single { Json {
        prettyPrint = true
        isLenient = true
        ignoreUnknownKeys = true
        explicitNulls = false
    }
    }
}

val pusherModule = module {
    single {
        PusherWebSocketService(
            client = get(),
            json = get(),
            appKey = "70131562ec9c2bc870d9",
            cluster = "ap1"
        )
    }
}